import { render, staticRenderFns } from "./Othpayables.vue?vue&type=template&id=391f7b58"
import script from "./Othpayables.vue?vue&type=script&lang=js"
export * from "./Othpayables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports